import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

import { queryKeys } from './use-data';

export const useWorkOrdersRefresh = () => {
	const queryClient = useQueryClient();
	return useCallback(
		() => queryClient.invalidateQueries({ queryKey: queryKeys.workOrders.all }),
		[queryClient],
	);
};
